export const isBrowserSupportedNotifications = () =>
    'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window
